import React from 'react';
import {
  HbrDropdown,
  HbrButton,
  HbrIcon,
} from '@harbor/elements-react-standalone';
import { user } from '@harbor/elements/icons';

const userProfileStyles = {
  labelBold: {
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'left' as const,
    lineHeight: '20px',
    padding: '0 12px',
  } as React.CSSProperties,
  menu: {
    padding: 16,
    display: 'flex',
    justifyContent: 'center',
  } as React.CSSProperties,
};

// placement="bottom-end" right-aligns the panel with its trigger so it opens
// inward from the right edge of the header instead of overflowing past it.
const UserProfileLoggedOut: React.FC<{ login: () => void }> = ({ login }) => (
  <HbrDropdown slot="user-profile" hoist menu distance={12} placement="bottom-end">
    <HbrButton noPadding slot="trigger" caret>
      <HbrIcon asset={user} style={{ fontSize: 24 }} slot="prefix" />
      <div style={userProfileStyles.labelBold}>Sign in</div>
    </HbrButton>
    <div style={userProfileStyles.menu}>
      <HbrButton sentiment="info" onClick={login}>Sign in</HbrButton>
    </div>
  </HbrDropdown>
);

export default UserProfileLoggedOut;